export default __webpack_public_path__ + "static/media/5.37d40155.png";